import * as React from "react";
import moment from "moment";
const ReactModal = require('react-modal');
import EventModal from "../../events/event-modal";
import CONSTS from "../../../consts";
export default class StoreEvents extends React.Component {
    constructor(props) {
        super(props);
        this.toggleModal = () => {
            this.setState({ toggle: !this.state.toggle });
        };
        this.onClick = () => {
            this.toggleModal();
        };
        this.onError = () => {
            this.setState({ imgPath: "" });
        };
        this.state = {
            StoreEvents: null,
            toggle: false,
            imgPath: this.props.imgPath || ""
        };
    }
    // componentWillReceiveProps(nextProps:StoreEventsProps) {
    //     if (nextProps.supplier !== this.props.supplier) {
    //         this.getStoreEvents(nextProps.supplier);
    //     }
    // }
    render() {
        let supplier = this.props.supplier;
        let event_background_image = `${CONSTS.STORAGEURL}/${CONSTS.LICENSEECONTAINER}/${supplier.Id}-Event.jpg`;
        let events = this.props.storeEvents;
        // Dirty way to trim whitespacing
        events = JSON.parse(JSON.stringify(events).replace(/"\s+|\s+"/g, '"'));
        let imgPath = this.state.imgPath;
        let img = imgPath ? React.createElement("div", { className: "event-img" },
            React.createElement("img", { alt: "pic", src: imgPath, onError: this.onError })) : null;
        return (React.createElement("div", null, events.length > 0 &&
            React.createElement("div", { className: "store-template-b__events", style: { backgroundImage: "url(" + event_background_image + ")" } },
                React.createElement("a", { "data-name": "events" }),
                React.createElement("div", { className: "store-template-b__events__wrap" },
                    React.createElement("h2", null, "Events"),
                    React.createElement("div", { className: "store-template-b__events__grid" }, events.map((event, index) => {
                        let timeformat = moment(new Date(event.StartDate)).format('L') === moment(new Date(event.EndDate)).format('L') ?
                            "h:mm A" : "MMM DD YYYY, h:mm A";
                        let time = `${moment(new Date(event.StartDate)).format('h:mm A')} - ${moment(new Date(event.EndDate)).format(timeformat)}`;
                        let modal = this.state.toggle ?
                            React.createElement(EventModal, Object.assign({}, event, { imgPath: imgPath, toggle: this.state.toggle, toggleModal: this.toggleModal }))
                            : null;
                        return React.createElement("div", { key: index, className: "store-template-b__events__grid__item", onClick: this.onClick },
                            modal,
                            React.createElement("div", { className: "date" },
                                React.createElement("span", { className: "month" },
                                    moment(new Date(event.StartDate)).format('MMM'),
                                    " ",
                                    moment(new Date(event.StartDate)).format('DD'))),
                            React.createElement("div", { className: "details" },
                                React.createElement("h3", null, event.Name)),
                            React.createElement("p", { className: "details" }, "Click for details"));
                    }))))));
    }
}
;
//# sourceMappingURL=events.js.map